module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }